import React from 'react'

const RangeOfMotion = (props) => {
    let { objectiveData, setObjectiveData, setSaveRangeOfMotionData, ObjectiveNotesProps, } = { ...props };
    let rangeOfMotion = objectiveData?.RangeOfMotion;
    const handleRangeOfMotion = (e) => {
        let { name } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setObjectiveData(prev => {
            console.log("handleObjectiveFindingobjectiveFindingData123", {
                ...prev,
                'RangeOfMotion': {
                    ...prev?.RangeOfMotion,
                    [name]: prev?.RangeOfMotion?.[name] === "true" ? "false" : "true",
                },
            })
            return ({
                ...prev,
                'RangeOfMotion': {
                    ...prev?.RangeOfMotion,
                    [name]: prev?.RangeOfMotion?.[name] === "true" ? "false" : "true",
                },
            });
        });

        setSaveRangeOfMotionData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }

    const handleChangeRangeOfMotionText = (e) => {
        let { name, value } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setObjectiveData(prev => {
            console.log("handleObjectiveFindingobjectiveFindingData123", {
                ...prev,
                'RangeOfMotion': { ...prev?.RangeOfMotion, [name]: value },
            })
            return ({
                ...prev,
                'RangeOfMotion': { ...prev?.RangeOfMotion, [name]: value },
            });
        });

        setSaveRangeOfMotionData(prev => ({ ...prev, [name]: value }));

    }
    return (
        <div className="d-flex flex-column gap-1">
            <p className="heading fs-13 lh-normal">Range of Motion (ROM):</p>
            <div className="d-flex gap-40">
                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="CervicalSpine"
                                checked={rangeOfMotion?.CervicalSpine === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Cervical Spine</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="ThoracicLumberSpine"
                                checked={rangeOfMotion?.ThoracicLumberSpine === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Thoracic & Lumbar Spine</p>
                    </label>
                </div>

                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="Shoulder"
                                checked={rangeOfMotion?.Shoulder === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Shoulder</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="Elbow"
                                checked={rangeOfMotion?.Elbow === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Elbow</p>
                    </label>
                </div>

                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="Forearm"
                                checked={rangeOfMotion?.Forearm === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Forearm</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="Wrist"
                                checked={rangeOfMotion?.Wrist === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Wrist</p>
                    </label>
                </div>

                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="Hip"
                                checked={rangeOfMotion?.Hip === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Hip</p>
                    </label>
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="Knee"
                                checked={rangeOfMotion?.Knee === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Knee</p>
                    </label>
                </div>

                <div className="d-flex flex-column gap-2">
                    <label className="d-flex align-items-center gap-6 user-select-none">
                        <div className="custom_check_box d-flex">
                            <input
                                type="checkbox"
                                className="form-check-input m-0 p-0"
                                name="Ankle"
                                checked={rangeOfMotion?.Ankle === "true"}
                                onChange={handleRangeOfMotion}
                            />
                        </div>
                        <p className="text lh-12">Ankle</p>
                    </label>
                </div>

            </div>

            {/* Cervical Spine ROM */}
            {rangeOfMotion?.CervicalSpine === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Cervical Spine ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading text-start font-m">Flexion</th>
                                <th className="heading" colSpan={2}>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="CS_Flexion"
                                            id="CS_Flexion"
                                            value={rangeOfMotion?.CS_Flexion}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Extension</p>
                                </td>
                                <td colSpan={2}>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="CS_Extension"
                                            id="CS_Extension"
                                            value={rangeOfMotion?.CS_Extension}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Lateral Flexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="CS_LateralFlexionLeft"
                                            id="CS_LateralFlexionLeft"
                                            value={rangeOfMotion?.CS_LateralFlexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="CS_LateralFlexionRight"
                                            id="CS_LateralFlexionRight"
                                            value={rangeOfMotion?.CS_LateralFlexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Rotation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="CS_RotationLeft"
                                            id="CS_RotationLeft"
                                            value={rangeOfMotion?.CS_RotationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="CS_RotationRight"
                                            id="CS_RotationRight"
                                            value={rangeOfMotion?.CS_RotationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                name="CS_Notes"
                                id="CS_Notes"
                                autoComplete='off'
                                rows={1}
                                value={rangeOfMotion?.CS_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

            {/* Thoracic & Lumbar Spine ROM  */}
            {rangeOfMotion?.ThoracicLumberSpine === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Thoracic & Lumbar Spine ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading text-start font-m">Flexion</th>
                                <th className="heading" colSpan={2}>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="TLS_Flexion"
                                            id="TLS_Flexion"
                                            value={rangeOfMotion?.TLS_Flexion}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Extension</p>
                                </td>
                                <td colSpan={2}>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="TLS_Extension"
                                            id="TLS_Extension"
                                            value={rangeOfMotion?.TLS_Extension}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Lateral Flexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="TLS_LateralFlexionLeft"
                                            id="TLS_LateralFlexionLeft"
                                            value={rangeOfMotion?.TLS_LateralFlexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="TLS_LateralFlexionRight"
                                            id="TLS_LateralFlexionRight"
                                            value={rangeOfMotion?.TLS_LateralFlexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Rotation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="TLS_RotationLeft"
                                            id="TLS_RotationLeft"
                                            value={rangeOfMotion?.TLS_RotationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="TLS_RotationRight"
                                            id="TLS_RotationRight"
                                            value={rangeOfMotion?.TLS_RotationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                autoComplete='off'
                                rows={1}
                                name="TLS_Notes"
                                id="TLS_Notes"
                                value={rangeOfMotion?.TLS_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

            {/* Shoulder ROM  */}

            {rangeOfMotion?.Shoulder === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Shoulder ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Flexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_FlexionLeft"
                                            id="Shoulder_FlexionLeft"
                                            value={rangeOfMotion?.Shoulder_FlexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_FlexionRight"
                                            id="Shoulder_FlexionRight"
                                            value={rangeOfMotion?.Shoulder_FlexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Extension</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_ExtensionLeft"
                                            id="Shoulder_ExtensionLeft"
                                            value={rangeOfMotion?.Shoulder_ExtensionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_ExtensionRight"
                                            id="Shoulder_ExtensionRight"
                                            value={rangeOfMotion?.Shoulder_ExtensionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Abduction</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_AbductionLeft"
                                            id="Shoulder_AbductionLeft"
                                            value={rangeOfMotion?.Shoulder_AbductionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_AbductionRight"
                                            id="Shoulder_AbductionRight"
                                            value={rangeOfMotion?.Shoulder_AbductionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Adduction</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_AdductionLeft"
                                            id="Shoulder_AdductionLeft"
                                            value={rangeOfMotion?.Shoulder_AdductionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_AdductionRight"
                                            id="Shoulder_AdductionRight"
                                            value={rangeOfMotion?.Shoulder_AdductionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Internal Rotation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_InternalRotationLeft"
                                            id="Shoulder_InternalRotationLeft"
                                            value={rangeOfMotion?.Shoulder_InternalRotationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_InternalRotationRight"
                                            id="Shoulder_InternalRotationRight"
                                            value={rangeOfMotion?.Shoulder_InternalRotationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">External Rotation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_ExternalRotationLeft"
                                            id="Shoulder_ExternalRotationLeft"
                                            value={rangeOfMotion?.Shoulder_ExternalRotationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Shoulder_ExternalRotationRight"
                                            id="Shoulder_ExternalRotationRight"
                                            value={rangeOfMotion?.Shoulder_ExternalRotationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                autoComplete='off'
                                rows={1}
                                name="Shoulder_Notes"
                                id="Shoulder_Notes"
                                value={rangeOfMotion?.Shoulder_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

            {/* Elbow  ROM  */}

            {rangeOfMotion?.Elbow === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Elbow ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Flexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Elbow_FlexionLeft"
                                            id="Elbow_FlexionLeft"
                                            value={rangeOfMotion?.Elbow_FlexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Elbow_FlexionRight"
                                            id="Elbow_FlexionRight"
                                            value={rangeOfMotion?.Elbow_FlexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Extension</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Elbow_ExtensionLeft"
                                            id="Elbow_ExtensionLeft"
                                            value={rangeOfMotion?.Elbow_ExtensionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Elbow_ExtensionRight"
                                            id="Elbow_ExtensionRight"
                                            value={rangeOfMotion?.Elbow_ExtensionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                autoComplete='off'
                                rows={1}
                                name="Elbow_Notes"
                                id="Elbow_Notes"
                                value={rangeOfMotion?.Elbow_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

            {/* Forearm   ROM  */}

            {rangeOfMotion?.Forearm === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Forearm ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Pronation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Forearm_PronationLeft"
                                            id="Forearm_PronationLeft"
                                            value={rangeOfMotion?.Forearm_PronationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Forearm_PronationRight"
                                            id="Forearm_PronationRight"
                                            value={rangeOfMotion?.Forearm_PronationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Supination</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Forearm_SupinationLeft"
                                            id="Forearm_SupinationLeft"
                                            value={rangeOfMotion?.Forearm_SupinationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Forearm_SupinationRight"
                                            id="Forearm_SupinationRight"
                                            value={rangeOfMotion?.Forearm_SupinationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                autoComplete='off'
                                rows={1}
                                name="Forearm_Notes"
                                id="Forearm_Notes"
                                value={rangeOfMotion?.Forearm_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

            {/* Wrist ROM  */}

            {rangeOfMotion?.Wrist === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Wrist ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Flexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Wrist_FlexionLeft"
                                            id="Wrist_FlexionLeft"
                                            value={rangeOfMotion?.Wrist_FlexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Wrist_FlexionRight"
                                            id="Wrist_FlexionRight"
                                            value={rangeOfMotion?.Wrist_FlexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Extension</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Wrist_ExtensionLeft"
                                            id="Wrist_ExtensionLeft"
                                            value={rangeOfMotion?.Wrist_ExtensionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Wrist_ExtensionRight"
                                            id="Wrist_ExtensionRight"
                                            value={rangeOfMotion?.Wrist_ExtensionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Radial Deviation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Wrist_RadialDeviationLeft"
                                            id="Wrist_RadialDeviationLeft"
                                            value={rangeOfMotion?.Wrist_RadialDeviationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Wrist_RadialDeviationRight"
                                            id="Wrist_RadialDeviationRight"
                                            value={rangeOfMotion?.Wrist_RadialDeviationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Ulnar Deviation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Wrist_UlnarDeviationLeft"
                                            id="Wrist_UlnarDeviationLeft"
                                            value={rangeOfMotion?.Wrist_UlnarDeviationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Wrist_UlnarDeviationRight"
                                            id="Wrist_UlnarDeviationRight"
                                            value={rangeOfMotion?.Wrist_UlnarDeviationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                autoComplete='off'
                                rows={1}
                                name="Wrist_Notes"
                                id="Wrist_Notes"
                                value={rangeOfMotion?.Wrist_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

            {/* Hip ROM  */}

            {rangeOfMotion?.Hip === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Hip ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Flexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_FlexionLeft"
                                            id="Hip_FlexionLeft"
                                            value={rangeOfMotion?.Hip_FlexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_FlexionRight"
                                            id="Hip_FlexionRight"
                                            value={rangeOfMotion?.Hip_FlexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Extension</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_ExtensionLeft"
                                            id="Hip_ExtensionLeft"
                                            value={rangeOfMotion?.Hip_ExtensionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_ExtensionRight"
                                            id="Hip_ExtensionRight"
                                            value={rangeOfMotion?.Hip_ExtensionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Abduction</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_AbductionLeft"
                                            id="Hip_AbductionLeft"
                                            value={rangeOfMotion?.Hip_AbductionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_AbductionRight"
                                            id="Hip_AbductionRight"
                                            value={rangeOfMotion?.Hip_AbductionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Adduction</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_AdductionLeft"
                                            id="Hip_AdductionLeft"
                                            value={rangeOfMotion?.Hip_AdductionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_AdductionRight"
                                            id="Hip_AdductionRight"
                                            value={rangeOfMotion?.Hip_AdductionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Internal Rotation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_InternalRotationLeft"
                                            id="Hip_InternalRotationLeft"
                                            value={rangeOfMotion?.Hip_InternalRotationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_InternalRotationRight"
                                            id="Hip_InternalRotationRight"
                                            value={rangeOfMotion?.Hip_InternalRotationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">External Rotation</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_ExternalRotationLeft"
                                            id="Hip_ExternalRotationLeft"
                                            value={rangeOfMotion?.Hip_ExternalRotationLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Hip_ExternalRotationRight"
                                            id="Hip_ExternalRotationRight"
                                            value={rangeOfMotion?.Hip_ExternalRotationRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                autoComplete='off'
                                rows={1}
                                name="Hip_Notes"
                                id="Hip_Notes"
                                value={rangeOfMotion?.Hip_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

            {/* Knee    ROM  */}

            {rangeOfMotion?.Knee === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Knee ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Flexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Knee_FlexionLeft"
                                            id="Knee_FlexionLeft"
                                            value={rangeOfMotion?.Knee_FlexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Knee_FlexionRight"
                                            id="Knee_FlexionRight"
                                            value={rangeOfMotion?.Knee_FlexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Extension</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Knee_ExtensionLeft"
                                            id="Knee_ExtensionLeft"
                                            value={rangeOfMotion?.Knee_ExtensionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Knee_ExtensionRight"
                                            id="Knee_ExtensionRight"
                                            value={rangeOfMotion?.Knee_ExtensionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                autoComplete='off'
                                rows={1}
                                name="Knee_Notes"
                                id="Knee_Notes"
                                value={rangeOfMotion?.Knee_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

            {/* Ankle ROM  */}

            {rangeOfMotion?.Ankle === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading">Ankle ROM:</p>
                    <table className='w-max-content'>
                        <thead>
                            <tr>
                                <th className="heading"></th>
                                <th className="heading">LEFT</th>
                                <th className="heading">RIGHT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p className="text font-m">Plantarflexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Ankle_PlantarflexionLeft"
                                            id="Ankle_PlantarflexionLeft"
                                            value={rangeOfMotion?.Ankle_PlantarflexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Ankle_PlantarflexionRight"
                                            id="Ankle_PlantarflexionRight"
                                            value={rangeOfMotion?.Ankle_PlantarflexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p className="text font-m">Dorsiflexion</p>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Ankle_DorsiflexionLeft"
                                            id="Ankle_DorsiflexionLeft"
                                            value={rangeOfMotion?.Ankle_DorsiflexionLeft}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='input mb-0'>
                                        <input type="text"
                                            className='form-control border-0 h-100 p-0 rounded-0'
                                            name="Ankle_DorsiflexionRight"
                                            id="Ankle_DorsiflexionRight"
                                            value={rangeOfMotion?.Ankle_DorsiflexionRight}
                                            onChange={handleChangeRangeOfMotionText}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
                    <div className="input">
                        <div className={"input"}>
                            <textarea
                                className="form-control"
                                autoComplete='off'
                                rows={1}
                                name="Ankle_Notes"
                                id="Ankle_Notes"
                                value={rangeOfMotion?.Ankle_Notes}
                                onChange={handleChangeRangeOfMotionText}
                            />
                        </div>
                    </div>
                </div> : <></>}

        </div>
    )
}

export default RangeOfMotion